// extracted by mini-css-extract-plugin
module.exports = {"instruction__link":"instruction_instruction__link__yKjnt","instruction__icon":"instruction_instruction__icon__5ZwvL"};